<div class="min-h-screen flex flex-col items-center justify-center bg-gray-50">
  <form
    #loginForm="ngForm"
    (ngSubmit)="loginForm.valid && login(loginForm)"
    [class.opacity-50]="loading()"
    [class.pointer-events-none]="loading()"
    class="bg-white p-8 rounded-xl shadow-md w-full max-w-sm relative"
    aria-labelledby="loginHeading"
  >
    <h2
      id="loginHeading"
      class="text-3xl font-bold text-gray-800 mb-8 text-center"
    >
      Login
    </h2>

    <!-- Username Field -->
    <div class="mb-6">
      <label for="username" class="block text-gray-700 font-semibold mb-2">
        Username
      </label>
      <input
        #usernameInput="ngModel"
        [(ngModel)]="username"
        (ngModelChange)="onFieldChange()"
        id="username"
        name="username"
        type="text"
        required
        placeholder="Enter your username"
        [disabled]="loading()"
        class="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
        [ngClass]="{
          'border-red-500 focus:ring-red-500':
            usernameInput.invalid &&
            (usernameInput.touched || usernameInput.dirty),
        }"
        [attr.aria-invalid]="usernameInput.invalid"
        [attr.aria-describedby]="
          usernameInput.invalid ? 'username-error' : null
        "
      />
      <p
        class="text-red-500 text-xs mt-1 ml-3"
        *ngIf="
          usernameInput.invalid &&
          (usernameInput.touched || usernameInput.dirty)
        "
        role="alert"
        aria-live="assertive"
      >
        Username is required.
      </p>
    </div>

    <!-- Password Field -->
    <div class="mb-6">
      <label for="password" class="block text-gray-700 font-semibold mb-2">
        Password
      </label>
      <input
        #passwordInput="ngModel"
        [(ngModel)]="password"
        (ngModelChange)="onFieldChange()"
        id="password"
        name="password"
        type="password"
        required
        placeholder="Enter your password"
        [disabled]="loading()"
        class="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
        [class.border-red-500]="
          passwordInput.invalid &&
          (passwordInput.touched || passwordInput.dirty)
        "
        [class.focus:ring-red-500]="
          passwordInput.invalid &&
          (passwordInput.touched || passwordInput.dirty)
        "
        [attr.aria-invalid]="passwordInput.invalid"
        [attr.aria-describedby]="passwordInput.invalid ? 'password-error' : null"
      />
      <p
        class="text-red-500 text-xs mt-1 ml-3"
        *ngIf="
          passwordInput.invalid &&
          (passwordInput.touched || passwordInput.dirty)
        "
        role="alert"
        aria-live="assertive"
      >
        Password is required.
      </p>
    </div>

    <button
      type="submit"
      [disabled]="loginForm.invalid || loading()"
      class="w-full bg-blue-500 text-white font-semibold py-2 rounded-lg transition hover:bg-blue-600 disabled:opacity-50 disabled:hover:bg-blue-500"
    >
      {{ loading() ? "Logging in..." : "Login" }}
    </button>

    <!-- Quick login buttons -->
    @if (demoMode) {
      <div class="mt-6 border-t pt-4">
        <p class="text-sm font-semibold text-gray-600 mb-2">
          Quick Login (For Demo Only)
        </p>
        <div class="grid grid-cols-2 gap-2">
          <button
            type="button"
            class="w-full bg-blue-200 hover:bg-blue-100 text-gray-700 font-medium py-2 rounded-lg transition"
            (click)="quickLogin('ADMIN', loginForm)"
            [disabled]="loading()"
          >
            Admin
          </button>
          <button
            type="button"
            class="w-full bg-gray-200 hover:bg-gray-100 text-gray-700 font-medium py-2 rounded-lg transition"
            (click)="quickLogin('EMPLOYEE', loginForm)"
            [disabled]="loading()"
          >
            Employee
          </button>
        </div>
      </div>
    }
    <!-- Error message -->
    @if (message()) {
      <p class="mt-4 text-sm text-red-500" 
      role="alert"
      aria-live="assertive">{{ message() }}</p>
    }
  </form>

  <p class="mt-4">
    Not a user yet?
    <a
      class="text-blue-600 hover:text-blue-800 underline"
      routerLink="/register"
      >Register Here</a
    >
  </p>
</div>
